/**
 * 360° Human Journey — 10 phases × 10 steps (100 total).
 * Source: 360_human_journey_100_steps.docx
 */

export const JOURNEY_PHASES = [
  {
    id: 1,
    name: 'Early exposure',
    shortName: 'Early exposure',
    stepRange: [1, 10],
    color: '#818cf8',
    gradient: 'linear-gradient(135deg, #6366f1 0%, #818cf8 100%)'
  },
  {
    id: 2,
    name: 'Academic finish line',
    shortName: 'Academic finish',
    stepRange: [11, 20],
    color: '#a78bfa',
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)'
  },
  {
    id: 3,
    name: 'Job seeking',
    shortName: 'Job seeking',
    stepRange: [21, 30],
    color: '#c084fc',
    gradient: 'linear-gradient(135deg, #9333ea 0%, #c084fc 100%)'
  },
  {
    id: 4,
    name: 'Upskill training',
    shortName: 'Upskill training',
    stepRange: [31, 40],
    color: '#e879f9',
    gradient: 'linear-gradient(135deg, #c026d3 0%, #e879f9 100%)'
  },
  {
    id: 5,
    name: 'Job finding',
    shortName: 'Job finding',
    stepRange: [41, 50],
    color: '#f472b6',
    gradient: 'linear-gradient(135deg, #db2777 0%, #f472b6 100%)'
  },
  {
    id: 6,
    name: 'Getting placed',
    shortName: 'Getting placed',
    stepRange: [51, 60],
    color: '#fb7185',
    gradient: 'linear-gradient(135deg, #e11d48 0%, #fb7185 100%)'
  },
  {
    id: 7,
    name: 'Certification upskilling',
    shortName: 'Certifications',
    stepRange: [61, 70],
    color: '#fbbf24',
    gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)'
  },
  {
    id: 8,
    name: 'Extra projects',
    shortName: 'Extra projects',
    stepRange: [71, 80],
    color: '#34d399',
    gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)'
  },
  {
    id: 9,
    name: 'Challenges & growth',
    shortName: 'Challenges',
    stepRange: [81, 90],
    color: '#38bdf8',
    gradient: 'linear-gradient(135deg, #0284c7 0%, #38bdf8 100%)'
  },
  {
    id: 10,
    name: 'Mastery & leadership',
    shortName: 'Mastery',
    stepRange: [91, 100],
    color: '#f97316',
    gradient: 'linear-gradient(135deg, #ea580c 0%, #fbbf24 100%)'
  }
];

export const JOURNEY_STEPS = [
  { step: 1, phaseId: 1, title: 'College project intern', description: 'First taste of real work applying classroom knowledge.' },
  { step: 2, phaseId: 1, title: 'Orientation to workplace culture', description: 'Understanding professional norms, hierarchies, and communication.' },
  { step: 3, phaseId: 1, title: 'First task delivery', description: 'Completing a real assignment under supervision.' },
  { step: 4, phaseId: 1, title: 'Skill gap discovery', description: 'Realising what academics never taught you on the job.' },
  { step: 5, phaseId: 1, title: 'Seeking feedback', description: 'Asking mentors and supervisors for honest critique.' },
  { step: 6, phaseId: 1, title: 'Personal reflection', description: 'Reviewing what you learned and what failed.' },
  { step: 7, phaseId: 1, title: 'Building first connections', description: 'Forming early professional relationships and contacts.' },
  { step: 8, phaseId: 1, title: 'Choosing a focus area', description: 'Narrowing down the domain or role you want to pursue.' },
  { step: 9, phaseId: 1, title: 'Time management basics', description: 'Learning to juggle deadlines, tasks, and personal time.' },
  { step: 10, phaseId: 1, title: 'End-of-internship review', description: 'Formal performance review and self-assessment wrap-up.' },
  { step: 11, phaseId: 2, title: 'Final-year internship', description: 'Securing a pre-graduation placement in a target industry.' },
  { step: 12, phaseId: 2, title: 'Capstone project', description: 'Designing and executing a major academic project.' },
  { step: 13, phaseId: 2, title: 'Industry exposure', description: 'Attending conferences, webinars, or campus placements.' },
  { step: 14, phaseId: 2, title: 'Resume building', description: 'Crafting a first professional resume with real experience.' },
  { step: 15, phaseId: 2, title: 'LinkedIn profile setup', description: 'Establishing an online professional identity.' },
  { step: 16, phaseId: 2, title: 'First portfolio creation', description: 'Documenting projects, code, or creative work publicly.' },
  { step: 17, phaseId: 2, title: 'Academic networking', description: 'Building relationships with professors and alumni.' },
  { step: 18, phaseId: 2, title: 'Soft skills training', description: 'Communication, teamwork, and presentation workshops.' },
  { step: 19, phaseId: 2, title: 'Competitive exam prep', description: 'GATE, GRE, or aptitude tests if required for target roles.' },
  { step: 20, phaseId: 2, title: 'Graduation milestone', description: 'Completing degree — marking the end of academic phase.' },
  { step: 21, phaseId: 3, title: 'Market research', description: 'Understanding which roles, companies, and skills are in demand.' },
  { step: 22, phaseId: 3, title: 'Job board mastery', description: 'Using LinkedIn, Naukri, Indeed, AngelList effectively.' },
  { step: 23, phaseId: 3, title: 'Application strategy', description: 'Targeting the right roles, not spray-and-pray applying.' },
  { step: 24, phaseId: 3, title: 'Cover letter writing', description: 'Crafting tailored cover letters for shortlisted roles.' },
  { step: 25, phaseId: 3, title: 'Mock interview practice', description: 'Rehearsing answers with peers, mentors, or platforms.' },
  { step: 26, phaseId: 3, title: 'Technical test prep', description: 'LeetCode, HackerRank, or domain-specific practice problems.' },
  { step: 27, phaseId: 3, title: 'Group discussion training', description: 'Practising structured debate and group problem-solving.' },
  { step: 28, phaseId: 3, title: 'Rejection handling', description: 'Reframing rejection as data, adjusting and persisting.' },
  { step: 29, phaseId: 3, title: 'Referral networking', description: 'Activating connections to get internal referrals.' },
  { step: 30, phaseId: 3, title: 'Offer negotiation basics', description: 'Learning to evaluate and negotiate salary and benefits.' },
  { step: 31, phaseId: 4, title: 'Core skill audit', description: 'Mapping current skills against job description requirements.' },
  { step: 32, phaseId: 4, title: 'Online course enrollment', description: 'Coursera, Udemy, edX, or YouTube-based structured learning.' },
  { step: 33, phaseId: 4, title: 'Hands-on project building', description: 'Applying new skills in a side project or personal repo.' },
  { step: 34, phaseId: 4, title: 'Community joining', description: 'Discord, Slack, or GitHub communities in your domain.' },
  { step: 35, phaseId: 4, title: 'Peer learning groups', description: 'Study groups to hold accountability and share resources.' },
  { step: 36, phaseId: 4, title: 'Hackathon participation', description: 'Time-boxed competitions to build fast and learn under pressure.' },
  { step: 37, phaseId: 4, title: 'Blogging or sharing learnings', description: 'Writing about what you learn to deepen understanding.' },
  { step: 38, phaseId: 4, title: 'Tool proficiency', description: 'Mastering industry-standard tools relevant to target role.' },
  { step: 39, phaseId: 4, title: 'Certification targeting', description: 'Identifying which credentials will maximise hiring chances.' },
  { step: 40, phaseId: 4, title: 'Skill demonstration', description: 'Building something shareable that proves you have levelled up.' },
  { step: 41, phaseId: 5, title: 'First interview call', description: 'Receiving and clearing an initial HR screening round.' },
  { step: 42, phaseId: 5, title: 'Technical round success', description: 'Passing domain or coding assessments confidently.' },
  { step: 43, phaseId: 5, title: 'Cultural fit assessment', description: 'Demonstrating alignment with company values and team dynamics.' },
  { step: 44, phaseId: 5, title: 'Final round interview', description: 'Facing leadership or panel interviews successfully.' },
  { step: 45, phaseId: 5, title: 'Background verification', description: 'Clearing BGV smoothly with correct documentation.' },
  { step: 46, phaseId: 5, title: 'Offer letter receipt', description: 'Getting the written offer and reading every clause carefully.' },
  { step: 47, phaseId: 5, title: 'Offer comparison', description: 'Comparing multiple offers across role, pay, growth, and culture.' },
  { step: 48, phaseId: 5, title: 'Joining date negotiation', description: 'Aligning on a start date that works for both parties.' },
  { step: 49, phaseId: 5, title: 'Pre-joining prep', description: 'Studying the company, team, and product before day one.' },
  { step: 50, phaseId: 5, title: 'Resignation or transition', description: 'Leaving previous role or college gracefully.' },
  { step: 51, phaseId: 6, title: 'Day one onboarding', description: 'Paperwork, ID, access setup, and meeting the team.' },
  { step: 52, phaseId: 6, title: 'Tool and system access', description: 'Setting up dev environment, comms tools, internal platforms.' },
  { step: 53, phaseId: 6, title: 'Understanding the product', description: 'Deep-diving into what the company builds and why.' },
  { step: 54, phaseId: 6, title: 'Team dynamic mapping', description: 'Learning who does what and who to go to for what.' },
  { step: 55, phaseId: 6, title: 'First standup participation', description: 'Contributing to daily team syncs and tracking cadences.' },
  { step: 56, phaseId: 6, title: 'First real task assignment', description: 'Delivering on an actual work item under guidance.' },
  { step: 57, phaseId: 6, title: 'Codebase or process walkthrough', description: 'Getting a senior to walk through core systems.' },
  { step: 58, phaseId: 6, title: 'Early wins', description: 'Delivering small, visible results that build credibility.' },
  { step: 59, phaseId: 6, title: 'Probation review', description: 'Formal or informal mid-probation check-in on performance.' },
  { step: 60, phaseId: 6, title: 'Probation completion', description: 'Passing the probation and becoming a confirmed employee.' },
  { step: 61, phaseId: 7, title: 'Role-aligned certification', description: 'AWS, GCP, PMP, CFA, or role-specific credential pursuit.' },
  { step: 62, phaseId: 7, title: 'Study plan creation', description: 'Structured 4–12 week plan to prepare for the exam.' },
  { step: 63, phaseId: 7, title: 'Practice exam sessions', description: 'Taking timed mock tests under real exam conditions.' },
  { step: 64, phaseId: 7, title: 'Peer study accountability', description: 'Studying with others for discipline and shared prep.' },
  { step: 65, phaseId: 7, title: 'Exam booking', description: 'Committing to a date to create real urgency.' },
  { step: 66, phaseId: 7, title: 'Exam attempt', description: 'Sitting the certification test.' },
  { step: 67, phaseId: 7, title: 'Result and reflection', description: 'Analysing what went well and what to improve.' },
  { step: 68, phaseId: 7, title: 'Certificate display', description: 'Adding credential to LinkedIn, resume, and portfolio.' },
  { step: 69, phaseId: 7, title: 'Next cert planning', description: 'Identifying the next logical certification in the stack.' },
  { step: 70, phaseId: 7, title: 'Knowledge application', description: 'Using certified skills in actual work projects.' },
  { step: 71, phaseId: 8, title: 'Side project ideation', description: 'Brainstorming ideas that solve a real or personal problem.' },
  { step: 72, phaseId: 8, title: 'Tech stack selection', description: 'Choosing tools and frameworks for the side project.' },
  { step: 73, phaseId: 8, title: 'MVP scoping', description: 'Defining the smallest version that proves the concept.' },
  { step: 74, phaseId: 8, title: 'Solo build sprint', description: 'Building the MVP over weekends or after work.' },
  { step: 75, phaseId: 8, title: 'Open-source contribution', description: 'Contributing to an existing project on GitHub.' },
  { step: 76, phaseId: 8, title: 'Freelance project', description: 'Taking on a paid side gig to build applied experience.' },
  { step: 77, phaseId: 8, title: 'Hackathon project', description: 'Building something under competition pressure.' },
  { step: 78, phaseId: 8, title: 'Project documentation', description: 'Writing a clear README, case study, or write-up.' },
  { step: 79, phaseId: 8, title: 'Public launch', description: 'Shipping the project and sharing on forums or social.' },
  { step: 80, phaseId: 8, title: 'Portfolio update', description: 'Adding the project to your live portfolio with outcomes.' },
  { step: 81, phaseId: 9, title: 'First major failure', description: 'Shipping a bug, missing a deadline, or getting harsh feedback.' },
  { step: 82, phaseId: 9, title: 'Imposter syndrome', description: 'Feeling unqualified despite genuine progress and results.' },
  { step: 83, phaseId: 9, title: 'Team conflict', description: 'Navigating disagreement, miscommunication, or friction.' },
  { step: 84, phaseId: 9, title: 'Workload overwhelm', description: 'Managing stress when scope exceeds capacity.' },
  { step: 85, phaseId: 9, title: 'Feedback processing', description: 'Receiving critical feedback and extracting growth from it.' },
  { step: 86, phaseId: 9, title: 'Skill plateau', description: 'Recognising stagnation and actively pushing past it.' },
  { step: 87, phaseId: 9, title: 'Burnout recognition', description: 'Identifying early signs and taking corrective action.' },
  { step: 88, phaseId: 9, title: 'Resilience building', description: 'Bouncing back and rebuilding confidence after setbacks.' },
  { step: 89, phaseId: 9, title: 'Stretch assignment', description: 'Voluntarily taking on a task beyond your current comfort.' },
  { step: 90, phaseId: 9, title: 'Major achievement', description: 'Delivering something significant and celebrating it.' },
  { step: 91, phaseId: 10, title: 'Senior role transition', description: 'Moving from individual contributor to senior-level scope.' },
  { step: 92, phaseId: 10, title: 'Mentoring others', description: 'Actively guiding a junior or new team member.' },
  { step: 93, phaseId: 10, title: 'Technical leadership', description: 'Owning architecture decisions or technical direction.' },
  { step: 94, phaseId: 10, title: 'Cross-team collaboration', description: 'Leading initiatives that span multiple teams or functions.' },
  { step: 95, phaseId: 10, title: 'Public speaking', description: 'Presenting at meetups, conferences, or internal all-hands.' },
  { step: 96, phaseId: 10, title: 'Thought leadership', description: 'Writing, speaking, or building in public to share expertise.' },
  { step: 97, phaseId: 10, title: 'Career specialisation', description: 'Going deep into a domain and becoming a recognised expert.' },
  { step: 98, phaseId: 10, title: 'Entrepreneurial move', description: 'Starting a venture, consultancy, or independent practice.' },
  { step: 99, phaseId: 10, title: 'Industry recognition', description: 'Awards, publications, open-source fame, or peer recognition.' },
  { step: 100, phaseId: 10, title: 'Full circle — next generation', description: 'Guiding the next college intern where you once stood.' }
];

export function getPhaseForStep(stepNumber) {
  return JOURNEY_PHASES.find((p) => stepNumber >= p.stepRange[0] && stepNumber <= p.stepRange[1]);
}

export function getStepByNumber(stepNumber) {
  return JOURNEY_STEPS.find((s) => s.step === stepNumber) || JOURNEY_STEPS[0];
}

/** Serpentine board layout: 10 steps per row, alternating direction. Returns { x, y } in 0–100 coords. */
export function getStepLayoutPosition(stepIndex) {
  const row = Math.floor(stepIndex / 10);
  const colInRow = stepIndex % 10;
  const col = row % 2 === 0 ? colInRow : 9 - colInRow;
  const xPad = 6;
  const yPad = 5;
  const xSpan = 88;
  const ySpan = 82;
  return {
    x: xPad + (col / 9) * xSpan,
    y: yPad + (row / 9) * ySpan,
    row,
    col
  };
}

/** SVG path through all 100 step centers (serpentine). */
export function buildSerpentinePathD() {
  const pts = JOURNEY_STEPS.map((_, i) => getStepLayoutPosition(i));
  if (pts.length === 0) return '';
  let d = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 1; i < pts.length; i += 1) {
    const prev = pts[i - 1];
    const cur = pts[i];
    if (prev.row !== cur.row) {
      const midY = (prev.y + cur.y) / 2;
      d += ` L ${prev.x} ${midY} L ${cur.x} ${midY}`;
    }
    d += ` L ${cur.x} ${cur.y}`;
  }
  return d;
}
